import Reflux  from 'reflux';
import Actions from './actions';
import FormActions from './form/actions'
import ErrorMessagesActions from './error-messages/actions';
import Tracking from 'medscape/tracking';

class EmailModalStore extends Reflux.Store {
  constructor() {
    super();
    this.state = this.getInitialState();
    this.listenables = Actions;
  }
  getInitialState() {
    return {
      modalIsOpen: false
    }
  }
  onOpen() {
    FormActions.reset();
    ErrorMessagesActions.update([]);
    this.setState({
        modalIsOpen: true
    });
  }
  onClose() {
    Tracking.track("share-email-close");
    this.setState({
        modalIsOpen: false
    });
  }
}

export default new EmailModalStore();



// WEBPACK FOOTER //
// ./medscape_modules/email-modal/store.js